import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PATHS_MAP } from "src/constants/paths";
import { useEffect } from "react";
import { useAppDispatch } from "src/redux/store";
import { getClient } from "src/redux/slices/client";
import JobsPage from "src/pages/job";
import CreateJobPage from "src/pages/job/create";
import JobDetailPage from "src/pages/job/detail";
import JobInvitePage from "src/pages/job/invite";
import InterviewDetailPage from "src/pages/job/interview/detail";
import SettingsPage from "src/pages/settings";
import TalentsPage from "src/pages/talent";
import TalentPage from "src/pages/talent/detail";
import UsagePage from "src/pages/usage";
import AtsPage from "src/pages/ats";
import AtsJobDetailPage from "src/pages/ats/jobs/detail";
import InterviewPage from "src/pages/interview";

const defaultPath = "/" + PATHS_MAP.job.path;

// Dedicated router for signed up users
const AuthenticatedRouter = () => {
  const dispatch = useAppDispatch();

  // Fetch the client profile once authenticated
  useEffect(() => {
    dispatch(getClient());
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} {...route} />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

const routes = [
  // Jobs
  {
    path: defaultPath,
    element: <JobsPage />
  },
  {
    path: PATHS_MAP.job.subs?.create,
    element: <CreateJobPage />
  },
  { path: PATHS_MAP.job.subs?.detail, element: <JobDetailPage /> },
  {
    path: PATHS_MAP.job.subs?.invite,
    element: <JobInvitePage />
  },
  // Interviews
  {
    path: PATHS_MAP.interview.path,
    element: <InterviewPage />
  },
  { path: PATHS_MAP.job.subs?.interview_detail, element: <InterviewDetailPage /> },
  // Talent
  { path: PATHS_MAP.talent.path, element: <TalentsPage /> },
  { path: PATHS_MAP.talent.subs?.detail, element: <TalentPage /> },
  // Settings
  { path: PATHS_MAP.settings.path, element: <SettingsPage /> },
  // Ats
  { path: PATHS_MAP.ats.path, element: <AtsPage /> },
  { path: PATHS_MAP.ats.subs?.job_detail, element: <AtsJobDetailPage /> },
  // Usage
  { path: PATHS_MAP.usage.path, element: <UsagePage /> },

  { path: "/*", element: <Navigate to={defaultPath} replace /> }
];

export default AuthenticatedRouter;
